<style scoped lang="scss" type="text/scss">
    .information-container {
        margin-top: 1rem;
        display: flex;
        align-items: flex-start;

        .left-panel {
            margin-right: 1rem;
        }

        .right-panel-container {
            flex: 1;
        }
    }
</style>

<template>
    <div class="information-wrap">
        <registrable-manged-player-selector></registrable-manged-player-selector>
        <div class="information-container">
            <left-panel class="left-panel"></left-panel>

            <card class="right-panel-container">
                <router-view></router-view>
            </card>
        </div>
        <count-down></count-down>
    </div>
</template>

<script>
    import LeftPanel from './left-panel';
    import Card from '../../../../components/card/index';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import CountDown from '../../../sub-components/count-down/index';

    export default {
        name: '',
        components: {
            RegistrableMangedPlayerSelector,
            LeftPanel,
            Card,
            CountDown
        },
        data () {
            return {};
        }
    };
</script>
